module.exports = __webpack_public_path__ + "img/logo.99b676f1.jpeg";